import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router'
import { Link, useParams } from 'react-router-dom'

import AddGroupMembershipsToUsersForm from '../../components/userAndGroupForms/AddGroupMembershipsToUsersForm/AddGroupMembershipsToUsersForm'
import useRoutes from '../../state/useRoutes'

export default React.memo(function AddMembersToGroupPage() {
  const { uuids: uuidsStr } = useParams()
  const uuids = useMemo(() => uuidsStr!.split(','), [uuidsStr])

  const { close } = useOutletContext<any>()

  return <AddGroupMembershipsToUsersForm userUuids={uuids} onClose={close} />
})

export function AddGroupMembershipsToUsersPageBreadcrumb() {
  const { uuids } = useParams()
  const { t } = useTranslation()
  const routes = useRoutes()
  return <Link to={routes.AddGroupMembershipsToUsers.url({ uuids: uuids! })}>{t('manage group.add to group')}</Link>
}
